import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminAISupportCenter = lazy(() => import("@/pages/admin/AdminAISupportCenter"));

export const Route = createFileRoute("/admin/ai-support")({
  component: AdminAISupportCenter,
});
